import React,{Fragment,useState,useEffect} from 'react';
import Formulario from './components/Formulario';
import Cita from './components/Cita';

function App() {

  //Citas en LocalS
  

  //Arreglo de citas
  const [citas,guardarCitas] = useState(()=>{
    let citasIniciales = JSON.parse(localStorage.getItem('citas'));
    if(!citasIniciales || citasIniciales === []){
      citasIniciales = [];
    }
    return citasIniciales;
  });

  //Use effect para realizar ciertas operaciones cuando el state cambia
  //SIEMPRE ES UNA ARROW FUNCTIONS
  //ES COMO EL EVENTO DE DOM CONTENT LOADER

  /* SE EJECUTA CUANDO EL COMPONENTE ESTA LISTO
  Y CUANDO HAY CAMBIOS */
  useEffect(()=>{
    localStorage.setItem('citas',JSON.stringify(citas));

  
  /* COMO SEGUNDO PARAMETRO
  UN ARREGLO VACIO PARA QUE SOLO SE EJECUTE 1 VEZ */
  },[citas]);

  //Funcion que tome las citas actuales y agregue las nuevas
  const crearCita = cita => {
    guardarCitas([...citas,cita]);
  }

  //Funcion que elimina su cita por id
  const eliminarCita = id =>{
    const citasActualizadas = citas.filter(cita => cita.id!==id);
    guardarCitas(citasActualizadas);
  }

  let titulo = citas.length === 0 ? 'No hay citas' : 'Administra tus citas';

  return (
    <Fragment>
      <h1>Administrador de pacientes</h1>

      <div className="container">
        <div className="row">
          <div className="one-half column"><Formulario
            crearCita = {crearCita}
          /></div>
          <div className="one-half column">
            <h2>{titulo}</h2>
            {citas.map(cita =>(
              <Cita
              key = {cita.id}
              cita = {cita}
              eliminarCita = {eliminarCita}
              />
            ))}
          </div>
        </div>
      </div>     
    </Fragment>
  )
}

export default App;
